namespace TabAurous.Inventory {
    export interface MixingItemsRow {
        TransactionId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        RoutingId?: number;
        GroupId?: number;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        HasBom?: boolean;
        DesignId?: number;
        DesignCode?: string;
        AttributeId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        CostMethodId?: number;
        Hsn?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        CalcOnId?: number;
        UnitRate?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        StoneRate?: number;
        OtherRate?: number;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        Lab?: string;
        StockAllocation?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
    }

    export namespace MixingItemsRow {
        export const idProperty = 'TransactionId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Inventory.MixingItems';
        export const deletePermission = 'Inventory:Mixing:Delete';
        export const insertPermission = 'Inventory:Mixing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Mixing:Edit';

        export declare const enum Fields {
            TransactionId = "TransactionId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            RoutingId = "RoutingId",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            HasBom = "HasBom",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            AttributeId = "AttributeId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            CostMethodId = "CostMethodId",
            Hsn = "Hsn",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            Lab = "Lab",
            StockAllocation = "StockAllocation",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount"
        }
    }
}
